import * as types from '../types.js';

function _syncPhysicalBlock(root)
{
	if (!root)
		return;
	const sel = root.querySelector('#warehouse_type');
	const v = sel ? String(sel.value || '1') : '1';
	const block = root.querySelector('#warehouse-physical-fields');
	if (block)
		block.style.display = v === '2' ? '' : 'none';
}

export default {

	html: `
		<style>
			#warehouse #company_id	{ width: 10rem;	}
			#warehouse #id			{ width: 5rem; text-align: right;	}
			#warehouse #name		{ width: 15rem;	}
			#warehouse #warehouse_type { width: 22rem; }
			#warehouse .wh-phys-grid { display: grid; grid-template-columns: 9rem 1fr; gap: 0.35rem 0.75rem; align-items: center; max-width: 42rem; }
			#warehouse .wh-phys-grid input { width: 100%; box-sizing: border-box; }
			#warehouse .wh-phys-grid label { justify-self: end; color: #444; font-size: 0.9rem; }
		</style>
		<form id="warehouse" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do armazém">Armazém
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome do armazém">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
			</div>
			<div class="fsb mtm">
				<label title="Armazém lógico: comportamento clássico SIAL. Armazém físico: local separado; com físicos na empresa, a geração de saídas exige escolher um.">Tipo
					<select id="warehouse_type">
						<option value="1">Armazém lógico (padrão SIAL)</option>
						<option value="2">Armazém físico (local distinto)</option>
					</select>
				</label>
			</div>
			<div id="warehouse-physical-fields" class="mtm" style="display:none">
				<div class="hint" style="font-size:0.85rem;color:#444;margin-bottom:0.5rem">
					Dados do armazém físico (opcionais — úteis para identificação do local). Com pelo menos um <strong>físico ativo</strong> na empresa, <strong>gerar saídas</strong> passa a exigir a escolha de um armazém físico.
				</div>
				<div class="wh-phys-grid">
					<label for="address_zipcode">CEP</label>
					<input id="address_zipcode" type="text" maxlength="20" autocomplete="postal-code">
					<label for="address_street">Rua</label>
					<input id="address_street" type="text" maxlength="200">
					<label for="address_number">Número</label>
					<input id="address_number" type="text" maxlength="40">
					<label for="address_complement">Complemento</label>
					<input id="address_complement" type="text" maxlength="120">
					<label for="address_city">Cidade</label>
					<input id="address_city" type="text" maxlength="120">
					<label for="address_state">UF</label>
					<input id="address_state" type="text" maxlength="2" placeholder="SP" title="Sigla UF, 2 letras">
					<label for="phone">Telefone</label>
					<input id="phone" type="text" maxlength="40">
				</div>
			</div>
			<div class="fsb mtm">
				<label title="Armazém inativo não entra em listas de escolha (entradas, saídas, estoque, posições, etc.). Só é possível inativar com estoque zerado em todas as posições.">
					<input id="is_disabled" type="checkbox"> Inativo
				</label>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,

	form:
	{
		selector: '#warehouse',
		init(formset)
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			const root = document.querySelector('#warehouse');
			const sel = root?.querySelector('#warehouse_type');
			if (sel)
				sel.addEventListener('change', () => _syncPhysicalBlock(root));
			Object.getPrototypeOf(this).init.call(this);
			_syncPhysicalBlock(root);
		},
		afterEditSetValues()
		{
			_syncPhysicalBlock(document.querySelector('#warehouse'));
		},
	},
	
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#name' }, types: [] },
		{ properties: { selector: '#warehouse_type' }, types: [types.pubsub()] },
		{ properties: { selector: '#address_zipcode' }, types: [] },
		{ properties: { selector: '#address_street' }, types: [] },
		{ properties: { selector: '#address_number' }, types: [] },
		{ properties: { selector: '#address_complement' }, types: [] },
		{ properties: { selector: '#address_city' }, types: [] },
		{ properties: { selector: '#address_state' }, types: [types.caps()] },
		{ properties: { selector: '#phone' }, types: [] },
		{ properties: { selector: '#is_disabled' }, types: [types.checkbox()] },
	]

};
